import { render, staticRenderFns } from "./DetailPosInventory.vue?vue&type=template&id=1f42e1bc&"
import script from "./DetailPosInventory.vue?vue&type=script&lang=js&"
export * from "./DetailPosInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports